// extracted by mini-css-extract-plugin
export default {"root":"JCK97c5eHUWkvx6X1y0V","loader":"QhksUR9GmFYpZQnfaBed","tableRow":"rL5ZulUEyf7LMzlgy84W"};